import { Alert } from "@mui/material";
import { useQueryClient } from "react-query";
import { FormattedMessage as T, useIntl } from "react-intl";
import useGlobalContext from "hooks/globalData";
import { FORM_ERROR } from "final-form";
import translateError from "utils/translateError";
import { ConfirmDialog } from "@knowfully/ui.common";

type ResendInviteDialogProps = {
  organizationUserId?: string;
  close: () => void;
};

export default function ResendInviteDialog({
  organizationUserId,
  close,
}: ResendInviteDialogProps) {
  const { formatMessage: t } = useIntl();
  const { organizationUserService } = useGlobalContext();
  const queryClient = useQueryClient();

  const submit = async () => {
    try {
      await organizationUserService.resendInvite(organizationUserId!);
      queryClient.invalidateQueries(["organizationUserService.getUsers"]);
      close();
    } catch (err: any) {
      return { [FORM_ERROR]: translateError(err, t) };
    }
  };

  const content = (
    <Alert severity="warning">
      <T id="userWillReceiveEmailInvitation" />
    </Alert>
  );

  return (
    <ConfirmDialog
      title={t({ id: "resendInvite" })}
      content={content}
      open={!!organizationUserId}
      onSubmit={submit}
      close={close}
    />
  );
}
